import {
  Phone,
  User,
  ShoppingCart,
  Laptop,
  AtSign,
  FileText,
  DollarSign,
  Pencil,
  Briefcase,
  PlusCircle,
} from "lucide-react"

const eventsIconMap = {
  "fa-phone": Phone,
  "fa-phone fa-flip-horizontal": Phone,
  "fa-user": User,
  "fa-shopping-cart": ShoppingCart,
  "fa-laptop": Laptop,
  "fa-share": AtSign,
  "fa-dollar-sign": DollarSign,
  "fa-pencil": Pencil,
  "fa-suitcase": Briefcase,
  "fa-plus-circle": PlusCircle,
  default: FileText,
} as const

type BackendIconKey = keyof typeof eventsIconMap
type IconComponent = (typeof eventsIconMap)[BackendIconKey]

export const eventsIconParser = (icon: string): IconComponent | null =>
  (icon ? eventsIconMap[icon as BackendIconKey] : null) ?? null
